import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AutenticacionGuard } from './shared/guard/autenticacion.guard';
import { MenuGuard } from './shared/guard/menu/menu.guard';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthComponent } from './theme/layout/auth/auth.component';

const routes: Routes = [
  {
    path: 'admin',
    component: AdminComponent,
    data: {
      externo: false,
    },
    children: [
      {
        path: 'cms',
        loadChildren: () => import('../app/cms/cms.module').then(module => module.CmsModule)
      },
      {
        path: 'ecommerce',
        loadChildren: () => import('../app/cms/menu/ecommerce/ecommerce.module').then(module => module.EcommerceModule)
      }
    ],
    canActivate: [AutenticacionGuard, MenuGuard],
  },
  {
    path: '',
    component: AuthComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
